<template>
  <div>
    <div class="TicketStep">
      <div class="TicketStep-header">
        <h3 class="TicketStep-heading"><strong>1</strong> Select ticket type</h3>
      </div>

      <div class="TicketStep-options" v-if="mq.mediumPlus">
        <div class="RadioBox" v-for="(item, index) in types" :key="index">
          <input 
            class="RadioBox-input"
            type="radio" 
            name="ticketType" 
            :id="`ticketType-${index}`" 
            :value="item"
            v-on:change="fetchTickets"
            v-model="selectedType"/>
          <label class="RadioBox-label" :for="`ticketType-${index}`">
            <span class="RadioBox-labelInner">{{item.label}}</span>
          </label>
        </div>
      </div>

      <div class="TicketStep-options" v-if="!mq.mediumPlus">
        <select 
        name="ticketType" 
        class="Select" v-model="selectedType" v-on:change="fetchTickets">
          <option :value="item" v-for="(item, index) in types" :key="index">
            {{item.label}}
          </option>
        </select>
      </div>

    </div>

    <div class="TicketStep" v-if="selectedType.showDays">
      <div class="TicketStep-header">
        <h3 class="TicketStep-heading"><strong>2</strong> Select Days</h3>
      </div>

      <div class="TicketStep-options" v-if="mq.mediumPlus">
        <div class="RadioBox" v-for="(item, index) in days" :key="index">
          <input 
            class="RadioBox-input"
            type="radio" 
            name="day" 
            :id="`day-${index}`" 
            :value="item"
            v-on:change="fetchTickets"
            v-model="selectedDay"/>
          <label class="RadioBox-label" :for="`day-${index}`">
            <span class="RadioBox-labelInner">{{item.label}}</span>
          </label>
        </div>
      </div>

      <div class="TicketStep-options" v-if="!mq.mediumPlus">
        <select 
        name="ticketType" 
        class="Select" v-model="selectedDay" v-on:change="fetchTickets">
          <option :value="item" v-for="(item, index) in days" :key="index">
            {{item.label}}
          </option>
        </select>
      </div>
    </div>

    <div class="TicketStep">
      <div class="TicketStep-header">
        <h3 class="TicketStep-heading"><strong>{{ selectedType.showDays ? 3 : 2 }}</strong> Select Tickets</h3>
        <button class="TicketStep-btn" @click="showInfo = true">
          <icon name="info"/>
          Important ticket information
        </button>
      </div>
      
      <modal :show="showInfo" title="Important ticket information" :content="info" icon="info" @close="showInfo = false" />

      <alert v-if="!isLoading && data.error">
        Sorry, there was a problem retrieving tickets. Please try again later.
      </alert>

      <div class="TicketList" v-if="!isLoading && !data.error">
        <div v-for="category in data" :key="category.categoryName">
          <h4 class="TicketList-category">{{category.categoryName}}</h4>
          <ul class="TicketList-items">
            <li class="TicketList-item" v-for="ticket in category.tickets" :key="ticket.id">
              <ticket v-bind="ticket" :basket="basket"/>
            </li>
          </ul>
        </div>
      </div>

      <spinner v-else-if="isLoading"/>
    </div>
  </div>
</template>

<script>
import { fetcher } from '../../../../utils/fetcher';
import Ticket from './Ticket.vue';
import Alert from '../UI/Alert.vue';
import Spinner from '../UI/Spinner.vue';
import Modal from '../UI/Modal.vue';
import Icon from '../UI/Icon.vue';

export default {
  inject: ["mq"],

  components: { Ticket, Alert, Spinner, Modal, Icon },

  data() {
    return {
      isLoading: false,
      showInfo: false,
      selectedType: this.types.length ? this.types[0] : null,
      selectedDay: this.days.length ? this.days[0] : null,
      data: []
    }
  },

  beforeMount() {
    this.fetchTickets();
  },

  methods: {
    async fetchTickets() {
      this.isLoading = true;

      this.data = await fetcher.post(this.endpoint, {
        type: this.selectedType.value,
        day: this.selectedDay.value
      });

      this.isLoading = false;
    },

    getNumbers:function(start,stop){
        return new Array((stop+1)-start).fill(start).map((n,i) => n+i);
    }
  },

  props: {
    endpoint: {
      type: String,
      default: null
    },
    types: {
      type: Array,
      default: () => []
    },
    days: {
      type: Array,
      default: () => []
    },
    info: String,
    basket: {
      type: String 
    }
  }
}
</script>